import url from "../constants/urls";
import apiHelper from "../helper/apiHelper";

async function fetchMedicalHistorySets() {
    return await apiHelper.makeApiCall(url.API_URL + url.FETCH_MEDICAL_HISTORY_SETS, "GET");
}
async function createMedicalHistorySet(data) {
    return await apiHelper.makeApiCall(
        url.API_URL + url.CREATE_MEDICAL_HISTORY_SET,
        "POST",
        data
    );
}
async function deleteMedicalHistorySet(id) {
    return await apiHelper.makeApiCall(
        `${url.API_URL}${url.DELETE_MEDICAL_HISTORY_SET}?id=${id}`,
        "DELETE",
        null
    );
}
async function fetchMedicalHistorySetId(id) {
    return await apiHelper.makeApiCall(url.API_URL + url.FETCH_MEDICAL_HISTORY_SET + `?id=${id}`, "GET");
}

async function addMedicalHistorySetQuestions(data) {
    return await apiHelper.makeApiCall(
        url.API_URL + url.ADD_MEDICAL_HISTORY_SET_QUESTIONS,
        "POST",
        data
    );
}
export default {
    fetchMedicalHistorySets,
    createMedicalHistorySet,
    deleteMedicalHistorySet,
    fetchMedicalHistorySetId,
    addMedicalHistorySetQuestions
};
